import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_MESSAGE_BUTTON_ORDER = defineFcm('psf_share_message_button_order')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'enum',
				values: [
					'copy',
					'mobileNativeShare',
					'facebook',
					'instagram',
					'whatsapp',
					'reddit',
					'twitter',
					'email',
					'facebookMessenger',
					'sms',
					'line',
					'vk',
					// TODO older names that we should phase out
					'copylink',
					'facebook_message',
				] as const,
			},
		}),
	)
	.withDefault(['copy', 'whatsapp', 'email', 'facebookMessenger', 'twitter', 'sms'])
	.toConfig({
		owner: 'TBD',
		// Read server-side only (getChannels.ts on the psf_share context).
		// `corgi-front-end` is kept for now to avoid breaking the FE schema field
		// `FeatureConfigs.psfShareMessageButtonOrder` while older clients may
		// still query it. Drop once those clients have rolled over.
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'PSF share page',
		description: 'Used to configure the buttons being displayed on the PSF page (non-initial) and their order',
		template: ['copy', 'whatsapp', 'line', 'facebookMessenger', 'twitter', 'email', 'sms'],
	});
